<style>
  .caption {
    margin: 0.1em 0.3em 0em 0.2em; /* top | right | bottom | left */
  }
</style>

<script>
  import config from '../../config';
  import { config_values, meteo_data_updated } from '../store';
  
  import MeteoWidget from './MeteoWidget.svelte';
  
  function get_widget_order() {
    let layout_id;
    if ($config_values.layout) {
      layout_id = $config_values.layout.choices[$config_values.layout.chosen].id;
    } else {
      let config_default = config.config_widgets.layout.default;
      layout_id = config_default.choices[config_default.chosen].id;
    }
    return layout_id.split('-');
  }
  
  function get_items(widget_type) {
    let items = [];
    if ($config_values[widget_type].chosen) {
      items.push($config_values[widget_type].chosen);
    } else {
      for (let key of Object.keys($config_values[widget_type])) {
        if ($config_values[widget_type][key].visible) {
          items.push(key);
        }
      }
    }
    items.sort();
    return items;
  }
  
  let order = get_widget_order();
  let items = [];
  $: {
    $meteo_data_updated;
    $config_values;
    order = get_widget_order();
    items = get_items(order[0]);
  }
</script>

<section class='vertical'>
  <div class='caption-left horiz-always unselectable'>
    <p class='big'>Meteo informācija <span class='small'>(atjaunota {$meteo_data_updated})</span></p>
  </div>
  {#key items}
    {#each items as key}
      <MeteoWidget next_order={order.slice(1)} prev_order={order.slice(0,1)} prev_ids={[key]} />
    {/each}
  {/key}
</section>
